import { Configuration, PublicClientApplication } from '@azure/msal-browser';

const { REACT_APP_ENTRA_TENANT_ID, REACT_APP_ENTRA_CLIENT_ID, REACT_APP_ENTRA_SCOPES, REACT_APP_ENTRA_REDIRECT_URI } =
    window.GattinoniAnagraphicForm;

export const msalConfig: Configuration = {
    auth: {
        clientId: REACT_APP_ENTRA_CLIENT_ID,
        authority: `https://login.microsoftonline.com/${REACT_APP_ENTRA_TENANT_ID}`,
        redirectUri: REACT_APP_ENTRA_REDIRECT_URI,
        postLogoutRedirectUri: REACT_APP_ENTRA_REDIRECT_URI,
        navigateToLoginRequestUrl: true,
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    },
};

// Runtime-configurable so switching to a dedicated API scope needs no code change
export const loginRequest = {
    scopes: REACT_APP_ENTRA_SCOPES.split(' ').filter(Boolean),
};

export const msalInstance = new PublicClientApplication(msalConfig);
